/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids */

/**
 * Init responsive videos
 */
fitvids();
